<template lang="pug">
nav.v-mobile-nav.mobile-nav
	ul.mobile-nav__panels(v-if="flatMenu && flatMenu.length")
		li.panel(v-for="(panel, panelIndex) in flatMenu" :class="{'panel--open': isPanelOpen(panel)}" :key="panelIndex")
			.panel__head.panel-head
				button.panel-head__btn.panel-head__btn--back(type="button" @click="back" v-if="panel.parentId !== '0'")
					v-svg-icon.panel-head__btn-icon(icon="back")
				.panel-head__title
					v-svg-icon.panel-head__icon(icon="logo-text")
				button.panel-head__btn.panel-head__btn--close(type="button" @click="close")
					v-svg-icon.panel-head__btn-icon(icon="close")
			ul.panel__body
				li.panel__item(v-for="(item, index) in panel.items" :key="index")
					a.panel__btn(
							:href="item.link || item.href"
							:data-modal-url="item.modalLink"
							:data-modal-data="item.modalData"
							:class="{'js-open-modal': item.modalLink || item.modalData}"
							tabindex="0"
							@click="itemClick(item, $event)")
						//- mobileText имеет приоритет над картинкой: у пункта профиля в
						//- десктопной шапке стоит аватар, а в бургере всем показываем
						//- «ID: N» (см. header_top_nav.php)
						.panel__btn-main(v-if="item.mobileText || item.text") {{item.mobileText || item.text}}
						img.panel__btn-image(v-else-if="item.image"
								:src="item.image?.src"
								:alt="item.image?.alt")
						v-svg-icon.panel__btn-arrow(v-if="item.hasItems" icon="chevron-right-sm")
						.panel__top(v-if="item.head" )
							.panel__location(v-if="item.head.location" )
								slot(name="location" )
							.panel__search(v-if="item.head.search" )
								slot(name="search" )
						.panel__favorite(v-if="item.favorite" )
							slot(name="favorite" )
			//- Переключатель языка: у авторизованного он убран из мобильной шапки и
			//- живёт здесь, внизу корневой панели, отдельным блоком под списком.
			//- Гостю languages не приходит — у него переключатель остаётся в шапке
			//- (см. header_top_nav.php).
			.panel__langs(v-if="panel.parentId === '0' && languages.length")
				a.panel__lang(
						v-for="(lang, langIndex) in languages"
						:key="langIndex"
						:href="lang.link"
						:class="{'panel__lang--active': lang.active}") {{lang.text}}

</template>

<script>
import breakpoints from '../scripts/breakpoints.js';
import controller from '../scripts/controller/controller.js';
import scrollLock from "scroll-lock";


export default {
	data() {
		return {
			menu: [],
			openPanels: [],
			openTimeout: null,
			closeTimeout: null,
			touch: controller.touch,
			flatMenu: null,
			languages: []
		};
	},

	created() {
		this.dataSet(controller.mobileNavData);
		controller.events.on('mobile-nav-updated', this.dataSet);
		controller.events.on('mobile-nav-open', this.open);
		controller.events.on('mobile-nav-close', this.close);
		window.addEventListener('resize', this.handleResize);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		window.removeEventListener('resize', this.handleResize);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {

		// Три кнопки языков внизу корневой панели. Данные приезжают тем же пунктом
		// name === 'lang', который из списка пунктов выбрасывается (см. updateFlatMenu):
		// PHP кладёт в него плоский список всех языков с флагом active, чтобы порядок
		// кнопок (EN/RU/GR) не зависел от того, какой язык выбран сейчас. Гостю
		// languages не приходит вовсе — у него переключатель остаётся в шапке.
		// Считаем здесь, а не в computed: controller мутирует ОДИН И ТОТ ЖЕ массив
		// (push + повторный dataSet с тем же объектом), поэтому реактивность на
		// this.menu не срабатывает — соседний flatMenu по той же причине
		// пересобирается вручную.
		findLanguages() {
			for (let group of (this.menu || [])) {
				let lang = (group.items || []).find(item => item?.name === 'lang');
				if (lang && lang.languages && lang.languages.length) {
					return lang.languages.slice();
				}
			}
			return [];
		},

		// Переупорядочивание пунктов ПЕРВОЙ панели мобильного меню (шторка справа).
		// Пункты приходят из разных групп (user / menu / top-menu), поэтому здесь мы
		// подправляем итоговый порядок под требования дизайна, не трогая десктопное меню:
		//   - «Добавить объявление» — вторым пунктом (сразу после «Войти»/профиля);
		//   - «Избранное» — последним пунктом.
		reorderFirstPanelItems(items) {
			let result = items.slice();

			// «Добавить объявление» опознаём по primary-классу кнопки.
			let addAdIndex = result.findIndex(item => item?.className && item.className.indexOf('btn--primary') >= 0);
			if (addAdIndex >= 0) {
				let addAd = result.splice(addAdIndex, 1)[0];
				result.splice(1, 0, addAd);
			}

			// «Избранное» опознаём по флагу favorite и переносим в самый конец.
			let favoriteIndex = result.findIndex(item => item?.favorite);
			if (favoriteIndex >= 0) {
				let favorite = result.splice(favoriteIndex, 1)[0];
				result.push(favorite);
			}

			return result;
		},

		updateFlatMenu() {
			console.log(this.menu)
			let result = [];
			if (this.menu) {
				let firstPanel = {
					text: '',
					itemId: '0',
					items: this.reorderFirstPanelItems(
						this.menu.reduce((acc, group) => group.items ? acc.concat(group.items.filter(item => item?.name !== 'lang')) : acc, [])
					)
				};
				let flattenMenuRecursive = (parentItem) => {
					if (parentItem.items && parentItem.items.length) {
						let panel = {
							parentId: parentItem.itemId,
							parentText: parentItem.text,
							items: []
						};
						parentItem.items.forEach((item, itemIndex) => {
							item.itemId = parentItem.itemId + '-' + itemIndex;
							panel.items.push({...item, menuId: null, items: null, hasItems: !!item.items && !!item.items.length});
							flattenMenuRecursive(item);
						});
						result.push(panel);
					}
				};
				flattenMenuRecursive(firstPanel);
				result.reverse();
			}
			this.flatMenu = result;
			this.languages = this.findLanguages();
		},

		dataSet(data) {
			this.menu = data;
			if (this.menu) {
				this.menu.sort((groupA, groupB) => {
					const order = {
						'catalog': -1,
						'menu': 2,
						'top-menu': 3,
						'user': 1
					};
					return (order[groupA.type] || 0) - (order[groupB.type] || 0);
				});
			}
			this.updateFlatMenu();
		},

		open() {
			document.body.classList.add('state--mobile-nav-open');
			this.openPanels = ['0'];
			scrollLock.disablePageScroll(document.querySelector('.mobile-nav__panels'));
		},

		close() {
			document.body.classList.remove('state--mobile-nav-open');
			this.openPanels = [];
			scrollLock.enablePageScroll(document.querySelector('.mobile-nav__panels'));
		},

		back() {
			this.openPanels.pop();
			if (!this.openPanels.length) {
				this.close();
			}
		},

		isPanelOpen(panel) {
			return this.openPanels.indexOf(panel.parentId) >= 0;
		},

		itemClick(item, e) {
			if (item.hasItems) {
				e.preventDefault();
				this.openPanels.push(item.itemId);
			}
		},

		handleResize() {
			if (window.innerWidth >= breakpoints['sm-max'] && this.openPanels && this.openPanels.length) {
				this.close();
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.openPanels.length) {
				e.stopPropagation();
				this.close();
			}
		},
	}
};
</script>